export const IconsGroup = {
  extends: 'Grid',
  lazyLoad: true,
  columns: 'repeat(12, 1fr)',
  gap: 'X',
  margin: '- -X2',
  limit: 60,
  data: async (el, s, ctx) => {
    // ⚠ This raw `fetch` breaks the SDK-only rule (workspace/CLAUDE.md) and
    // Rule 47. This lane only stops the crash — where the icon asset read
    // BELONGS is a separate decision (it is a design-system icon set, not
    // component data). Until that lands, a failed read must degrade to an
    // empty grid, never to an unhandled rejection.
    if (!el?.call) return []
    let defIcons
    try {
      const res = await fetch('https://assets.symbo.ls/icons/def_icons.json')
      defIcons = await res.json()
    } catch (err) {
      el.warn?.('IconsGroup: the icon library did not load', err)
      return []
    }
    const data = el.call('arraizeIconsCategory', defIcons)
    // `deepClone` resolves through context.utils, which a host is free not
    // to register; `el.call` then answers undefined by framework contract.
    return el.call('deepClone', data) || data || []
  },
  childExtends: 'IconTemplate',
  childrenAs: 'state',
  children: async (el, s) => {
    const limit = el.limit
    const resolved = s.data || el.data ? await el.call('exec', el.data) : []
    // `exec(param, element)` answers undefined for a function param when no
    // element is forwarded (smbls utils/object.js), and an icon read that
    // never arrived answers undefined too. Children must always be an array.
    const data = Array.isArray(resolved) ? resolved : []
    if (limit) return data.slice(0, limit)
    return data
  },
};